import React from 'react'

const Spinners = () => {
    return (
        <div className="spin m-auto text-center">

            <div className="spinner-border text-warning" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            
        </div>
    )
}

export default Spinners
